const API_HOST = process.env.REACT_APP_API_HOST;

const authHeaders = () => {
  const token = localStorage.getItem("jwt");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const postJson = async (path, payload, options = {}) => {
  const response = await fetch(`${API_HOST}${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload || {}),
    signal: options.signal,
  });

  const result = await response.json();
  if (!result?.success) {
    throw new Error(result?.message || "Failed to fetch bets");
  }
  return result.data;
};

export const fetchOperatorBetList = (payload, options) =>
  postJson("/operator/getBetsList", payload, options);

export const fetchOperatorBetFilterValues = (column, search = "", options = {}) =>
  postJson(
    "/operator/getBetFilterValues",
    {
      column,
      search,
      limit: options.limit ?? 100,
      offset: options.offset ?? 0,
    },
    options
  );

export { toAgGridColumnFilters } from "./betListServerSide";
